module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/next-6067598f46df4df71cf762c473383d9d.svg";